import React, { useEffect, useState } from "react";
import { CustomButton } from "../../../components/main_comps/custom_button";
import MainComponent from "../../../components/ui_comps/MainComponent";
import { AiOutlinePlus } from "react-icons/ai";
import CustomTable from "../../../components/main_comps/custom_table";
import { showHideFilterModalReducer } from "../../../../data/redux/slice/globalFiltersSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  colorDarkBlue,
  primaryColor,
} from "../../../../utility/constants/colorManager";
import {
  VanAllCustomerHeaders,
  VanCustomerHeaders,
} from "../../../../utility/TableHeaders";
import ResizeListner from "../../../../utility/ResizeListner";
import { setHeaders } from "../../../../services/aclValidateServiceTable";
import { getVanCustomerList } from "../../../../services/fetchListingData";
import { ApiRequestGet } from "../../../../data/network/services/ApiRequestGet";
import {
  CLIENT,
  CUSTOMER_DOWNLOAD_REPORT,
  CUSTOMER_LIST,
  RESELLER,
  STATUS_CODE_200,
  TRANSACTION_VAN_ACL,
} from "../../../../utility/constants/valueConstants";
import CustomSelect from "../../../components/main_comps/custom_select";
import { CustomViewModal } from "../../../components/main_comps/custom_modal/CustomViewModal";
import CustomModal from "../../../components/main_comps/custom_modal";
import DownloadReportCustomer from "./DownloadReportCustomer";
import moment from "moment";
import { SS_ROLE } from "../../../../utility/constants/secureStorageManager";
import secureStorage from "../../../../services/secureStorage";

export const RemitterAcc = ({ data }) => {
  return (
    <div style={{ color: "rgba(122, 121, 121, 1)" }}>
      {data?.remitterAcc?.map((obj, index) => (
        <div key={index} style={{ margin: "10px" }}>
          <p style={{ marginBottom: "4px" }}>{`Remitter Acc Details ${
            index + 1
          }`}</p>
          <p
            style={{ marginBottom: "2px" }}
          >{`Account Number: ${obj.remitterAccNumber}`}</p>
          <p>{`IFSC Code: ${obj.remitterAccIfsc}`}</p>
        </div>
      ))}
    </div>
  );
};

const FilterComponent = ({ onChange, onPress }) => {
  const [vanServiceList, setVanServiceList] = useState([]);
  const [currentServiceProvider, setCurrentServiceProvider] = useState({});
  const role = secureStorage.getItem(SS_ROLE);
  const aclData = useSelector((state) => state.aclSlice.aclList);
  const modififyDropdownServiceProviderNameList = (data) => {
    let arr = [];
    data &&
      data?.map((val, i) => {
        arr.push({
          value: val?.serviceProviderName,
          label: val.serviceProviderName,
        });
      });

    return arr;
  };

  useEffect(() => {
    fetchVanDropDown();
  }, []);

  useEffect(() => {
    if (role?.toUpperCase() === RESELLER) {
      fetchResellerVanDropDown();
    } else {
      fetchVanDropDown();
    }
  }, []);

  const fetchVanDropDown = () => {
    ApiRequestGet.getAllServiceProviderList({
      type: "van",
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          let Data = modififyDropdownServiceProviderNameList(res.data);
          const modifdData = Data.filter((item) => item.value !== "Equitas");
          setVanServiceList(modifdData);
        }
      })
      .catch((err) => {});
  };

  const fetchResellerVanDropDown = () => {
    ApiRequestGet.fetchResellerServiceProvider({
      servicetype: "van",
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          let Data = modififyDropdownServiceProviderNameList(res.data);
          const modifdData = Data.filter(
            (item) => item.value.toLowerCase() !== "equitas"
          );
          setVanServiceList(modifdData);
        }
      })
      .catch((err) => {});
  };

  useEffect(() => {
    setCurrentServiceProvider(vanServiceList[0]);
  }, [vanServiceList]);
  useEffect(() => {
    onChange(currentServiceProvider?.value);
  }, [currentServiceProvider]);

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      {role !== CLIENT && (
        <>
          <CustomSelect
            options={vanServiceList}
            isSearchable={false}
            onChange={(data) => {
              onChange(data?.value);
              setCurrentServiceProvider(data);
            }}
            value={currentServiceProvider}
            style={{
              height: 40,
              backgroundColor: "rgba(111, 108, 255, 0.1)",
              border: "1px solid #001777",
              "&:hover": {
                border: "1px solid #001777",
              },
              borderRadius: "4px",
            }}
          />
        </>
      )}
      {aclData?.includes(CUSTOMER_DOWNLOAD_REPORT) && (
        <>
          <CustomButton
            title="Download Report"
            backgroundColor="#38369C"
            onClick={onPress}
          />
        </>
      )}
    </div>
  );
};

const VanCustomerIndex = ({}) => {
  const { width, height } = ResizeListner();
  const [selectedService, setSelectedService] = useState("");
  const [viewMoreModal, setViewMoreModal] = useState(false);
  const filters = useSelector((state) => state.globalFiltersSlice);
  const [viewMoreData, setViewMoreData] = useState({});
  const [reportModal, setReportModal] = useState(false);
  const vanCustomerListData = useSelector(
    (state) => state.listingSlice.vanAllCustomerList
  );
  const clientSecret = useSelector((state) => state.listingSlice.clientDetails);
  const dispatch = useDispatch();
  const role = secureStorage.getItem(SS_ROLE);
  const aclData = useSelector((state) => state.aclSlice.aclList);
  const [clientDetails, setClientDetials] = useState({});
  useEffect(() => {
    dispatch(
      getVanCustomerList({
        page: 0,
        size: 10,
        dateRange: "",
        customerHashId: "",
        clientHashId: "",
        status: "",
        van: "",
        name: "",
        createdby: "",
        resellerId: "",
        serviceProviderName:
          role === CLIENT
            ? clientDetails?.serviceProviderName
            : selectedService,
        email: "",
        mobileNumber: "",
      })
    );
  }, [selectedService]);

  const setHeaders = (data, role, acl) => {
    let arr = [];

    data &&
      data?.map((val, i) => {
        if (val?.roles || val?.acl) {
          if (val?.roles?.includes(role) || acl?.includes(val?.acl))
            arr.push({
              title: val?.title,
              key: val?.key,
            });
        } else {
          arr.push({
            title: val?.title,
            key: val?.key,
          });
        }
      });
    return arr;
  };

  const getClientProgram = () => {
    let van = clientSecret.filter((obj) => obj.serviceType === "van");
    if (van.length > 0) {
      setClientDetials(van[0]);
    }
  };

  useEffect(() => {
    if (role === CLIENT) {
      getClientProgram();
    }
  }, []);

  return (
    <div
      style={{
        width: "100%",
        overflow: "auto",
        boxSizing: "border-box",
        backgroundColor: "white",
      }}
    >
      <MainComponent
        notificationRequired={false}
        onClickFilter={() => {
          dispatch(
            showHideFilterModalReducer({
              showFilterModal: true,
              filters: [
                "dateRange",
                "clientName",
                "resellerName",
                "email",
                "mobileNumber",
                "vanNumber",
                "status",
              ],
            })
          );
        }}
        onClickFilterCall={(data) => {
          dispatch(
            getVanCustomerList({
              page: 0,
              size: 10,
              dateRange:
                data?.fromDate && data?.toDate
                  ? moment(data?.fromDate).format("DD/MM/YYYY") +
                    "-" +
                    moment(data?.toDate).format("DD/MM/YYYY")
                  : "",
              customerHashId: "",
              clientHashId: data?.clientId?.value ?? "",
              status: data?.status?.value ?? "",
              van: data?.van ?? "",
              name: "",
              createdby: "",
              resellerId: data?.resellerId?.value ?? "",
              serviceProviderName:
                role === CLIENT
                  ? clientDetails?.serviceProviderName
                  : selectedService,
              email: data?.email ?? "",
              mobileNumber: data?.mobileNumber ?? "",
            })
          );
        }}
        filterRequired={true}
        headerTitle="Customers"
      />
      <div style={{ display: "flex", justifyContent: "right", margin: "10px" }}>
        <FilterComponent
          onChange={(data) => {
            setSelectedService(data);
          }}
          onPress={() => setReportModal(true)}
        />
      </div>

      {aclData?.includes(CUSTOMER_LIST) && (
        <>
          <div style={{ padding: "0px 20px", overflow: "hidden" }}>
            <CustomTable
              styles={{
                maxHeight: height * 0.7,
                minHeight: height * 0.7,
              }}
              data={vanCustomerListData?.customers}
              headers={setHeaders(VanAllCustomerHeaders, role)}
              totalElements={vanCustomerListData?.totalRecords}
              currentPage={vanCustomerListData?.currentPageNo - 1}
              totalPages={vanCustomerListData?.totalPages}
              handlePaginate={(page) => {
                dispatch(
                  getVanCustomerList({
                    page: page + 1,
                    size: 10,
                    dateRange:
                      filters?.fromDate && filters?.toDate
                        ? moment(filters?.fromDate).format("DD/MM/YYYY") +
                          "-" +
                          moment(filters?.toDate).format("DD/MM/YYYY")
                        : "",
                    customerHashId: "",
                    clientHashId: filters?.clientId?.value ?? "",
                    status: filters?.status?.value ?? "",
                    van: filters?.van ?? "",
                    name: "",
                    createdby: "",
                    resellerId: filters?.resellerId?.value ?? "",
                    serviceProviderName:
                      role === CLIENT
                        ? clientDetails?.serviceProviderName
                        : selectedService,
                    email: filters?.email ?? "",
                    mobileNumber: filters?.mobileNumber ?? "",
                  })
                );
              }}
              onViewMore={(row) => {
                setViewMoreModal(true);
                setViewMoreData(row);
              }}
              onStatusChange={() => {}}
            />
            {viewMoreModal && (
              <CustomModal
                open={viewMoreModal}
                onClose={() => {
                  setViewMoreModal(false);
                  // setDataForModal({});
                }}
                headerTitle={"Account Details"}
                containerStyle={{
                  minWidth: 350,
                  maxWidth: 400,
                  borderRadius: "20px 0px 0px 20px",
                  height: "auto",
                }}
                isHeaderRequired={true}
              >
                <RemitterAcc data={viewMoreData} />
              </CustomModal>
            )}
          </div>
        </>
      )}

      {reportModal && (
        <CustomModal
          headerTitle="Download Report"
          open={reportModal}
          onClose={() => {
            setReportModal(false);
          }}
          containerStyle={{
            minWidth: 350,
            maxWidth: 450,
            height: "auto",
            maxHeight: 800,
          }}
        >
          <DownloadReportCustomer
            onChange={(val) => {
              setReportModal(val);
            }}
            selectedServiceProvider={selectedService}
          />
        </CustomModal>
      )}
    </div>
  );
};

export default VanCustomerIndex;
